// @flow

export function auditMethod(methodName: string) {
    // istanbul ignore next
    if (
        typeof window !== 'undefined' &&
        window.newrelic &&
        typeof window.newrelic.addPageAction === 'function'
    ) {
        // to more easily determine where this method may be being used
        window.newrelic.addPageAction('dibs-cookie-jar:audit', {
            methodName,
            href: window.location.href,
        });
    }
}
